 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780718096427_COVER from '@/components/text/9780718096427_cover'
 import TEXT9780718096427_FRONTMATTER from '@/components/text/9780718096427_frontmatter'
 import TEXT9780718096427_TITLE from '@/components/text/9780718096427_title'
 import TEXT9780718096427_COPYRIGHT from '@/components/text/9780718096427_copyright'
 import TEXT9780718096427_FRONTMATTER3 from '@/components/text/9780718096427_Frontmatter3'
 import TEXT9780718096427_DEDICATION from '@/components/text/9780718096427_dedication'
 import TEXT9780718096427_FRONTMATTER1 from '@/components/text/9780718096427_frontmatter1'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780718096427_SECTION1 from '@/components/text/9780718096427_section1'
 import TEXT9780718096427_CHAPTER1 from '@/components/text/9780718096427_chapter1'
 import TEXT9780718096427_CHAPTER2 from '@/components/text/9780718096427_chapter2'
 import TEXT9780718096427_CHAPTER3 from '@/components/text/9780718096427_chapter3'
 import TEXT9780718096427_CHAPTER4 from '@/components/text/9780718096427_chapter4'
 import TEXT9780718096427_SECTION2 from '@/components/text/9780718096427_section2'
 import TEXT9780718096427_CHAPTER5 from '@/components/text/9780718096427_chapter5'
 import TEXT9780718096427_CHAPTER6 from '@/components/text/9780718096427_chapter6'
 import TEXT9780718096427_CHAPTER7 from '@/components/text/9780718096427_chapter7'
 import TEXT9780718096427_CHAPTER8 from '@/components/text/9780718096427_chapter8'
 import TEXT9780718096427_CHAPTER9 from '@/components/text/9780718096427_chapter9'
 import TEXT9780718096427_CHAPTER10 from '@/components/text/9780718096427_chapter10'
 import TEXT9780718096427_CHAPTER11 from '@/components/text/9780718096427_chapter11'
 import TEXT9780718096427_SECTION3 from '@/components/text/9780718096427_section3'
 import TEXT9780718096427_CHAPTER12 from '@/components/text/9780718096427_chapter12'
 import TEXT9780718096427_CHAPTER13 from '@/components/text/9780718096427_chapter13'
 import TEXT9780718096427_SECTION4 from '@/components/text/9780718096427_section4'
 import TEXT9780718096427_CHAPTER14 from '@/components/text/9780718096427_chapter14'
 import TEXT9780718096427_CHAPTER15 from '@/components/text/9780718096427_chapter15'
 import TEXT9780718096427_CHAPTER16 from '@/components/text/9780718096427_chapter16'
 import TEXT9780718096427_SECTION5 from '@/components/text/9780718096427_section5'
 import TEXT9780718096427_CHAPTER17 from '@/components/text/9780718096427_chapter17'
 import TEXT9780718096427_CHAPTER18 from '@/components/text/9780718096427_chapter18'
 import TEXT9780718096427_EPILOGUE from '@/components/text/9780718096427_epilogue'
 import TEXT9780718096427_MEDIA from '@/components/text/9780718096427_media'
 import TEXT9780718096427_ACKNOWLEDGMENTS from '@/components/text/9780718096427_acknowledgments'
 import TEXT9780718096427_NOTES from '@/components/text/9780718096427_notes'
 import TEXT9780718096427_ABOUTTHEAUTHOR from '@/components/text/9780718096427_abouttheauthor'
 import TEXT9780718096427_BACKMATTER from '@/components/text/9780718096427_backmatter'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js